import { NgComponentOutlet } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { FidelityAppNavigationService } from '../../../modules/fidelity-app/fidelity-app.nav-service';
import { NgComponentOutletItem } from '../../../modules/fidelity-app/fidelity-app.types';

/**
 * Component that provides a wrapper for overlay pages in the Fidelity app.
 * It includes a standard header with back navigation and network-error state handling.
 *
 * Features:
 * - Consistent header styling across overlay pages
 * - Back navigation functionality
 * - Error state display capability
 * - Material design components integration
 */
@Component({
    selector: 'fidelity-overlay-page-wrapper',
    imports: [MatIcon, MatRipple, MatButton, NgComponentOutlet],
    templateUrl: './fidelity-overlay-page-wrapper.component.html',
    styleUrl: './fidelity-overlay-page-wrapper.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class FidelityOverlayPageWrapperComponent {
    /**
     * Required input for the header caption text
     */
    headerCaption = input.required<string>();

    /**
     * Optional input for displaying network-error states using NgComponentOutlet
     */
    errorComponent = input<NgComponentOutletItem>();

    constructor(protected fidelityAppNavService: FidelityAppNavigationService) {}

    /**
     * Navigates back to the previous page using the FidelityAppNavigationService
     */
    navBack() {
        this.fidelityAppNavService.back();
    }
}
